import img1 from "./gallery1.jpg";
import img2 from "./gallery2.jpg";
import img3 from "./gallery3.jpg";

const images = [img1, img2, img3];

export default images;
  